import React from "react";
import styled from "styled-components";

function Help(props) {
  return (
    <RootWrapperReferralstwo>
      <Section>
        <Wrapper>
          <Frame1635>
            <Title>Need Help?</Title>
            <SupportSection>
              <SectionTitle>Email Support</SectionTitle>
              <SectionText>
                If you have any questions or need assistance, please contact us
                at{" "}
                <EmailLink href="mailto:support@paartner.com">
                  support@paartner.com
                </EmailLink>
              </SectionText>
            </SupportSection>

            <SupportSection>
              <SectionTitle>Response Time</SectionTitle>
              <SectionText>
                We aim to respond within one working day.
              </SectionText>
            </SupportSection>
            <SupportSection>
              <SectionTitle>Referral Support</SectionTitle>
              <SectionText>
                For questions related to a specific referral, please include
                relevant details, such as the referral ID, to help us assist you
                more efficiently.
              </SectionText>
            </SupportSection>
          </Frame1635>
          <Frame1634>
            <img
              src={
                "https://d3nakrlcog1u3z.cloudfront.net/1758192779710-owlhelp.png"
              }
              alt="Help illustration"
            />
          </Frame1634>
        </Wrapper>
      </Section>
    </RootWrapperReferralstwo>
  );
}

export default Help;

const RootWrapperReferralstwo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  background: rgb(255, 255, 255);

  @media (max-width: 768px) {
    padding-top: 60px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  padding: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
  background: var(--Color-Backgound-Light---1, #f1f5f9);
  flex: 1;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 60px;
  flex-direction: row;
  align-items: center;
  gap: var(--Padding-Normal, 16px);
  align-self: stretch;
  border-radius: 32px;
  border: 1px solid var(--stroke-soft-200, #e1e4ea);
  background: var(--bg-white-0, #fff);
  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding: 40px;
    gap: 24px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 32px 24px;
    border-radius: 24px;
    gap: 32px;
  }

  @media (max-width: 480px) {
    padding: 24px 16px;
    border-radius: 16px;
  }
`;

const Frame1635 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1;
  max-width: 668px;
  width: 100%;

  @media (max-width: 768px) {
    max-width: 100%;
    order: 2;
  }
`;

const Frame1634 = styled.div`
  display: flex;
  width: 388px;
  height: 365px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  img {
    max-width: 100%;
    height: auto;
    flex-shrink: 0;
    aspect-ratio: 306/365;
  }

  @media (max-width: 1024px) {
    width: 320px;
    height: 300px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
    height: auto;
    order: 1;
  }

  @media (max-width: 480px) {
    max-width: 250px;
  }
`;

const Title = styled.h1`
  color: var(--Color-Text-Text, #212543);
  font-family: Montserrat;
  font-size: var(--Fonts-H3, 48px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.96px;
  align-self: stretch;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 40px;
    letter-spacing: -0.8px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    letter-spacing: -0.72px;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 32px;
    letter-spacing: -0.64px;
  }
`;

const SupportSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

const SectionTitle = styled.h2`
  color: var(--Color-Brand-Primary, #212543);
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  align-self: stretch;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const SectionText = styled.p`
  color: var(--Color-Brand-Primary, #212543);
  font-family: Montserrat;
  font-size: var(--Fonts-P1, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  margin: 0;

  span {
    color: var(--Color-Brand-Primary, #212543);
    font-family: Montserrat;
    font-size: var(--Fonts-P1, 20px);
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }

  @media (max-width: 768px) {
    font-size: 16px;

    span {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    font-size: 14px;

    span {
      font-size: 14px;
    }
  }
`;

const EmailLink = styled.a`
  color: #3b82f6;
  text-decoration: underline;

  &:hover {
    color: #2563eb;
  }

  @media (max-width: 480px) {
    word-break: break-word;
  }
`;
